export default __webpack_public_path__ + "highf11e41.png";